import Paginator from '../_paginator'
import http from '../api'

let getAll = (config) => {
  return new Paginator({
    url: '/pdfs/',
    config: config
  });
}
let getAllDocuments = (config) => {
  return new Paginator({
    url: '/pdfs/',
    config: config
  });
}
let getAllDocumentsPaths = (config) => {
  return new Paginator({
    url: '/pdfs-donwload/',
    config: config
  });
}

let getDocument = (id) => {
  return http.get(`pdfs/${id}`)
}

let getAzure = (path) => {
  return http.post('file-azure', path);
};


export default {
  getAll,
  getAllDocuments,
  getAllDocumentsPaths,
  getDocument,
  getAzure,
}